import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ModuleList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50 },
			{ Header: 'moduleTitle', accessor: 'moduleTitle', filterType: FilterType.string },
			{ Header: 'category', accessor: 'category', filterType: FilterType.string },
			{ Header: 'slug', accessor: 'slug', filterType: FilterType.string },
			{ Header: 'icon', accessor: 'moduleIcon', filterType: FilterType.string },
			{
				Header: 'relatedModules',
				accessor: 'relatedModules',
				renderCell: ListComponents.TEXT_ARRAY,
				filterType: FilterType.string
			},
			{
				Header: 'showNewBadge',
				accessor: 'isNew',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS
			}
		],
		[]
	);
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	return (
		<DynamicList
			id={DYNAMICLISTS.MODULES}
			columns={columns}
			defaultSort={defaultSort}
			fetchUrl={ADMIN.CONFIGURATION.GET_MODULES_LIST}
			actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
		/>
	);
};

export default ModuleList;
